// export const progress = (id, timestamp=new Date().toString()) => ({
//   type: 'value/progress',
//   timestamp,
//   id,
// })
export const update = (value) => ({
  type: "moment/update",
  value,
});

export const create = (value) => ({
  type: "moments/create",
  value,
});

export const add = (values) => ({
  type: "moments/add",
  values,
});

// export const show = (id) => ({
//   type: 'value/show',
//   id,
// })

export const index = (values) => ({
  type: "moments/index",
  values,
});
